// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row__Bc7q {
  min-width: 100% !important;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/stationTimeline/TableSplitView.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;AACd","sourcesContent":[".row {\n  min-width: 100% !important;\n  height: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row__Bc7q`
};
export default ___CSS_LOADER_EXPORT___;
